import React, { useState } from 'react';
import './RAGContextDisplay.css';

const RAGContextDisplay = ({ references }) => {
    const [expandedChunks, setExpandedChunks] = useState(new Set());
    const [sortBy, setSortBy] = useState('similarity'); // 'similarity' or 'influence'

    if (!references || references.length === 0) {
        return (
            <div className="rag-context-display no-data">
                <p>No RAG context references available</p>
            </div>
        );
    }

    const toggleChunk = (chunkId) => {
        const newExpanded = new Set(expandedChunks);
        if (newExpanded.has(chunkId)) {
            newExpanded.delete(chunkId);
        } else {
            newExpanded.add(chunkId);
        }
        setExpandedChunks(newExpanded);
    };

    const sortedReferences = [...references].sort((a, b) => {
        if (sortBy === 'similarity') {
            return (b.similarity_score || 0) - (a.similarity_score || 0);
        } else {
            // Sort by influence (alphabetical for now, could be enhanced)
            return (a.influence || '').localeCompare(b.influence || '');
        }
    });

    const avgSimilarity = references.reduce(
        (sum, ref) => sum + (ref.similarity_score || 0),
        0
    ) / references.length;

    return (
        <div className="rag-context-display">
            <div className="rag-header">
                <div className="rag-stats">
                    <div className="stat-item">
                        <span className="stat-label">Total Chunks:</span>
                        <span className="stat-value">{references.length}</span>
                    </div>
                    <div className="stat-item">
                        <span className="stat-label">Avg Similarity:</span>
                        <span className="stat-value">{(avgSimilarity * 100).toFixed(1)}%</span>
                    </div>
                </div>
                <div className="rag-controls">
                    <label>
                        Sort by:
                        <select value={sortBy} onChange={(e) => setSortBy(e.target.value)}>
                            <option value="similarity">Similarity Score</option>
                            <option value="influence">Influence</option>
                        </select>
                    </label>
                </div>
            </div>

            <div className="rag-chunks">
                {sortedReferences.map((ref, idx) => {
                    const isExpanded = expandedChunks.has(ref.chunk_id || idx);
                    const similarityPercent = ((ref.similarity_score || 0) * 100).toFixed(1);

                    return (
                        <div key={ref.chunk_id || idx} className="rag-chunk">
                            <div
                                className="rag-chunk-header"
                                onClick={() => toggleChunk(ref.chunk_id || idx)}
                            >
                                <div className="chunk-header-left">
                                    <span className="chunk-id">Chunk #{idx + 1}</span>
                                    {ref.job_requirement && (
                                        <span className="job-requirement-badge">
                                            {ref.job_requirement}
                                        </span>
                                    )}
                                </div>
                                <div className="chunk-header-right">
                                    <div className="similarity-badge">
                                        <span className="similarity-label">Similarity:</span>
                                        <span className="similarity-value">{similarityPercent}%</span>
                                    </div>
                                    <span className="expand-icon">{isExpanded ? '▼' : '▶'}</span>
                                </div>
                            </div>

                            {isExpanded && (
                                <div className="rag-chunk-content">
                                    <div className="chunk-influence">
                                        <strong>Influence:</strong>
                                        <p>{ref.influence || 'No influence description available'}</p>
                                    </div>

                                    <div className="chunk-text">
                                        <strong>Chunk Text:</strong>
                                        <div className="chunk-text-content">
                                            {ref.chunk_text || 'No text content available'}
                                        </div>
                                    </div>

                                    {ref.job_requirement && (
                                        <div className="chunk-requirement">
                                            <strong>Related Job Requirement:</strong>
                                            <p>{ref.job_requirement}</p>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default RAGContextDisplay;

